import React from "react";
import { useTestCreationContext } from "../../../context/TestCreationContext";
import CreateInfoModal from "../InfoModal/CreateInfoModal";
import { useT } from "@transifex/react";
import styled from "styled-components";

/** Controlled usage: the modal ignores the context's pending-cards state. */
interface ControlledVocabTrainingLimitModalProps {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

/** Uncontrolled usage: visibility and actions come from the creation context. */
interface UncontrolledVocabTrainingLimitModalProps {
    isOpen?: undefined;
    onConfirm?: undefined;
    onCancel?: undefined;
}

export type VocabTrainingLimitModalProps =
    | ControlledVocabTrainingLimitModalProps
    | UncontrolledVocabTrainingLimitModalProps;

const ContentWrapper = styled.div`
    text-align: left;
    width: 100%;
    padding-right: 1rem;
`;

const VocabTrainingLimitModal: React.FC<VocabTrainingLimitModalProps> = (props) => {
    const {
        isLargeVocabConfirmVisible,
        confirmLargeVocabTraining,
        cancelLargeVocabTraining,
        maxAmountOfCardsSelectable,
    } = useTestCreationContext();

    const t = useT();
    const t_question = t("Do you really want to assign more than {maxAmountOfCards} words?", {
        maxAmountOfCards: maxAmountOfCardsSelectable,
        _tags: "CreateTest,UnitAndCardsWrapper",
    });
    const t_yes = t("Yes", { _tags: "CreateTest,UnitAndCardsWrapper" });
    const t_cancel = t("Cancel", { _tags: "CreateTest,UnitAndCardsWrapper" });

    const isOpen = props.isOpen ?? isLargeVocabConfirmVisible;
    const confirm = props.onConfirm ?? confirmLargeVocabTraining;
    const cancel = props.onCancel ?? cancelLargeVocabTraining;

    return (
        <CreateInfoModal
            isOpen={isOpen}
            onRequestClose={cancel}
            cancelAction={cancel}
            cancelText={t_cancel}
            continueAction={confirm}
            continueText={t_yes}
            compact
        >
            <ContentWrapper>{t_question}</ContentWrapper>
        </CreateInfoModal>
    );
};

export default VocabTrainingLimitModal;
